import type {
  TimelineItem,
  WithInfiniteScrollLoaderProps,
} from "./asset-timeline-scroll-loader.type";

import { AssetTimelineScrollLoader } from "./asset-timeline-scroll-loader.component";

export const withInfiniteScrollLoader = ({
  items,
  isFetchingNextPage,
}: WithInfiniteScrollLoaderProps): TimelineItem[] => {
  if (!isFetchingNextPage) return items;

  const nextPageLoaderItem: TimelineItem = {
    icon: <AssetTimelineScrollLoader />,
    className: "asset-timeline-item-scroll-loader",
  };

  return [...items, ...[nextPageLoaderItem]];
};
